export const CalculateSidewallHeight = (requestObject) => {
    requestObject ??= {};

    const result = {
        isValid: false,
        errors: [],
        sidewallHeight: null,
        wheelOffset: null,
        wheelBackspacing: null,
        finalWheelSize: null,
    }

    requestObject.tireWidth = parseFloat(`${requestObject.tireWidth}`);
    requestObject.tireAspectRatio = parseFloat(`${requestObject.tireAspectRatio}`);

    if (ValidateSidewallHeightInput(requestObject, result)) {
        return result;
    }

    result.sidewallHeight = CalculateSidewallHeightMetric(requestObject);
    // console.log(res)
    result.isValid = true;
    return result;
}

export const CalculateWheelOffsetEvent = (requestObject) => {
    requestObject ??= {};

    const result = {
        isValid: false,
        errors: [],
        sidewallHeight: null,
        wheelOffset: null,
        wheelBackspacing: null,
        finalWheelSize: null,
    }

    requestObject.tireWidth = parseFloat(`${requestObject.tireWidth}`);
    requestObject.tireSpacing = parseFloat(`${requestObject.tireSpacing}`);

    if (ValidateWheelOffsetInput(requestObject, result)) {
        return result;
    }

    result.wheelOffset = CalculateWheelOffset(requestObject);
    result.isValid = true;
    return result;
}

export const CalculateWheelBackspacingEvent = (requestObject) => {
    requestObject ??= {};

    const result = {
        isValid: false,
        errors: [],
        sidewallHeight: null,
        wheelOffset: null,
        wheelBackspacing: null,
        finalWheelSize: null,
    }

    requestObject.tireWidth = parseFloat(`${requestObject.tireWidth}`);
    requestObject.tireSpacing = parseFloat(`${requestObject.tireSpacing}`);
    requestObject.wheelWidth = parseFloat(`${requestObject.wheelWidth}`);

    if (ValidateWheelBackspacingInput(requestObject, result)) {
        return result;
    }

    result.wheelBackspacing = CalculateWheelBackspacing(requestObject);
    console.log("Wheel Backspacing here: ", result.wheelBackspacing);
    result.isValid = true;
    return result;
}

export const CalculateFinalWheelSize = (requestObject) => {
    requestObject ??= {};

    const result = {
        isValid: false,
        errors: [],
        sidewallHeight: null,
        wheelOffset: null,
        wheelBackspacing: null,
        finalWheelSize: null,
    }

    result.finalWheelSize = `Final Wheel Size: ${requestObject.wheelDiameter} X ${requestObject.wheelWidth}, ${Math.round(requestObject.wheelBackspacing)} in backspace, ${Math.round(requestObject.wheelOffset)} offset`
    result.isValid = true;
    return result;
}

const ValidateSidewallHeightInput = (requestObject, result) => {

    if (isNaN(requestObject.tireWidth)) {
        result.errors.push({
            id: "tireWidth",
            message: "Please enter a valid number"
        })
    }
    if (isNaN(requestObject.tireAspectRatio)) {
        result.errors.push({
            id: "tireAspectRatio",
            message: "Please select a valid number"
        })
    }
    return result.errors.length > 0
}

const ValidateWheelOffsetInput = (requestObject, result) => {

    if (isNaN(requestObject.tireWidth)) {
        result.errors.push({
            id: "tireWidth",
            message: "Please enter a valid number"
        })
    }
    if (isNaN(requestObject.tireSpacing)) {
        result.errors.push({
            id: "tireSpacing",
            message: "Please select a valid number"
        })
    }
    return result.errors.length > 0
}

const ValidateWheelBackspacingInput = (requestObject, result) => {

    if (isNaN(requestObject.tireWidth)) {
        result.errors.push({
            id: "tireWidth",
            message: "Please enter a valid number"
        })
    }
    if (isNaN(requestObject.tireSpacing)) {
        result.errors.push({
            id: "tireSpacing",
            message: "Please select a valid number"
        })
    }
    if (isNaN(requestObject.wheelWidth)) {
        result.errors.push({
            id: "wheelWidth",
            message: "Please select a valid number"
        })
    }
    return result.errors.length > 0
}

const CalculateSidewallHeightMetric = (requestObject) => {
    return (requestObject.tireAspectRatio / 100) * requestObject.tireWidth
}

const CalculateSidewallHeightImperial = (requestObject) => {
    return (requestObject.tireDiameter - requestObject.wheelDiameter) / 2;
}

const CalculateWheelOffset = (requestObject) => {
    if (!requestObject.isMetric) {
        let mmTireWidth = ConvertInchesToMm(requestObject.tireWidth);
        let mmTireSpacing = ConvertInchesToMm(requestObject.tireSpacing);
        return ((mmTireWidth) / 2) - mmTireSpacing;
    }
    return ((requestObject.tireWidth) / 2) - requestObject.tireSpacing;
}

// Always returns backspacing in inches
const CalculateWheelBackspacing = (requestObject) =>
{
    // if things are in mm, convert them to inches
    if (requestObject.isMetric)
    {
        // wheel width is given in inches
        let tireWidthInInches = ConvertMmToInches(requestObject.tireWidth);
        let tireSpacingInInches = ConvertMmToInches(requestObject.tireSpacing);

        return (((tireWidthInInches + requestObject.wheelWidth) / 2) - tireSpacingInInches) + 0.5;
    }

    return (((requestObject.tireWidth + requestObject.wheelWidth) / 2) - requestObject.tireSpacing) + 0.5;
}

const ConvertInchesToMm = (number) => {
    return (Math.round((number * 25.4) * 100) / 100);
}

export const ConvertMmToInches = (number) => {
    return (Math.round((number / 25.4) * 100) / 100);
}